module.exports = __webpack_public_path__ + "static/media/member_favorite_01.df5ee577.jpg";